import { useState } from "react"
import { dismissWordmarkNotice } from "../../lib/api"

// Once per subscription, for a new Pro owner (#343): every render reads the
// owner's plan, so the next download of a code has no tangoqr mark, but a file
// saved on the free plan, and anything printed from it, keeps the mark. The
// server decides when this is due (`wordmark_notice` on /me: a code made before
// the subscription that renders clean now). A service message: no pricing, no
// offer. The dismissal is saved on the subscription.
//
// useUser caches /me for the life of the page, so this remembers the dismissal
// for the same life, and a trip to Profile and back doesn't bring it back.
let dismissed = false

export default function CleanCopyNotice() {
  const [open, setOpen] = useState(!dismissed)
  if (!open) return null

  async function dismiss() {
    dismissed = true
    setOpen(false)
    try {
      await dismissWordmarkNotice()
    } catch {
      // Gone for now. It comes back on the next load, which is the honest
      // result of a save that didn't land (a staff view-as session, say).
    }
  }

  return (
    <div role="status" className="border border-[color:var(--color-border)] dark:border-storm bg-white dark:bg-midnight rounded-lg p-4 flex items-start justify-between gap-4">
      <p className="text-sm text-ink dark:text-cloud">
        Your codes now download without the tangoqr mark. Files you saved on the free plan, and anything printed from them, still have it. Download a fresh copy before you reprint.
      </p>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-[color:var(--color-muted)] dark:text-muted-light hover:text-coal dark:hover:text-cloud p-1 bg-transparent border-0 cursor-pointer flex-shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-voltage rounded"
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
      </button>
    </div>
  )
}
